export const retrieveAssemblyData = [
    'connectedDevice',
    'deviceVersion',
    'shield',
    'armShield',
    'dragingItem',
    'AppDetails-new',
    'AppDetails',
    'recoveryData',
    'IMGEURL',
    'assempblyImageHTML',
    'assempblyImageURI',
    'assemblyCheckbox',
    'Index',
    'SelectedComp',
    'coverflowActive',
    'Types',
    'Types3',
    'Types5',
    'editorCode',
    'pythonCode',
    'CurrentLogicScreen',
    'programEnd',
    'EndSwitch',
    'PET',
    'currentActiveHexBlock',
    'SelectedStatus',
    'rangeValCheckbox',
    'HumanoidActiveBtn',
    'logic',
    'assembly',
    'concept',
    'dualsplitter',
    'humanoidPortData',
    'humanoidProgramData',
    'servoControlModes',
]

export const retrieveFlowDataExcept = [
    'connectedDevice',
    'deviceVersion',
    'shield',
    'armShield',
    'dragingItem',
    'AppDetails-new',
    'recoveryData',
    'IMGEURL',
    'assempblyImageHTML',
    'assempblyImageURI',
    'assemblyCheckbox',
    'Index',
    'SelectedComp',
    'coverflowActive',
    'Types',
    'Types3',
    'Types5',
    'editorCode',
    'pythonCode',
    'CurrentLogicScreen',
    'programEnd',
    'EndSwitch',
    'PET',
    'currentActiveHexBlock',
    'SelectedStatus',
    'rangeValCheckbox',
    'HumanoidActiveBtn',
    'logic',
    'assembly',
    'concept',
    'dualsplitter',
]
// sessionStorage keys that hold the in-progress program; cleared when the user
// declines to recover the previous program
export const previousProgramSessionKeys = [
    'logic',
    'assembly',
    'concept',
    'humanoidProgramData',
    'humanoidPortData',
    'createActionState',
    'programEnd',
    'EndSwitch',
    'PET',
    'SelectedStatus',
    'currentActiveHexBlock',
    'assemblyCheckbox',
    'rangeValCheckbox',
    'HumanoidActiveBtn',
    'servoControlModes',
    'dualsplitter',
    'editorCode',
    'pythonCode',
    'assempblyImageHTML',
    'assempblyImageURI',
]
/*

 graphPlotStorage
nodeCounter
 isReadingZingPA
flow-logic
 AppDetails

*/
